import { render, staticRenderFns } from "./ExclusivePrivilege.vue?vue&type=template&id=c422d056"
import script from "./ExclusivePrivilege.vue?vue&type=script&lang=js"
export * from "./ExclusivePrivilege.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports